import { css } from 'linaria';
"s1jr340n";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/style/index.linaria.css");